module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/timeline_1-d998e627a54de17965c2109820708030.svg";